import { baseBUCGet } from '../base/baseBUC';

const int = 0;
const str = '';
const dateTimeStr = new Date()?.toISOString();

export const condominiumBoardElectionModelGet = ({buildingId = '', userId = ''}) => {
    return {
        description: str,
        remark: str,
        startDate: dateTimeStr,
        endDate: dateTimeStr,
        status: int,
        statusDate: dateTimeStr,
        ...baseBUCGet({buildingId: buildingId, userId: userId, }),
    }
};